import React, { useState } from "react";
import { Tab, Tabs } from "@heroui/react";
import { FaTruck, FaTools } from "react-icons/fa";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { Button } from "@heroui/button";
import { AddOutlined, Sync } from "@mui/icons-material";
import { Datepicker } from "@ijavad805/react-datepicker";
import ModalSelectPeymankar from "../../components/Modal/Peymankar/PeymankarSelectModal";
import ModalSelectMachine from "../../components/Modal/Machine/ModalMachineSelect";
import ModalSelectLocation from "../../components/Modal/Locations/LocationSelectModal";
import { toast } from "react-toastify";
import ModalDriverSingleWithData from "../../components/Modal/Driver/DriverSingleWithData";
import ModalSelectEquipment from "../../components/Modal/Equipment/ModalEquipmentSelect";
import { storeFunction } from "../../actions/function_registration/function_registration";
import { storeStop } from "../../actions/stop_registration/stop_registration";
import TimeInput24h from "../../components/TimeInput";

export default function StopRegistration() {
  const [tabRowState,setTabRowState] = useState(1)
  const [rows, setRows] = useState([
    {
      id: 1,
      startDate: "",
      endDate: "",
      contractor_data: {id:"","title":""},
      driver_data: {id:"",title:""},
      machine: {id:"",title:""},
      startTime: "",
      endTime: "",
      allowedHours: "",
      overtime: "",
      approvedWorkHours: "",
      location: {id:"",title:""},
      description: "",
    },
  ]);
  const [activeRowId, setActiveRowId] = useState(null);
  const [openModalPeymankar, setOpenModalPeymankar] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalLocation, setOpenModalLocation] = useState(false);
  const [openModalDriver, setOpenModalDriver] = useState(false);
  const [openModalEquipment, setOpenModalEquipment] = useState(false);
  const [loading,setLoading] = useState(false);
  const handleInputChange = (id, field, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };
  const [drivers,setDrivers] = useState([]);

  const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1,
      startDate: "",
      endDate: "",
      contractor_data: {id:"","title":""},
      driver_data: {id:"",name:""},
      machine: {id:"",title:""},
      startTime: "",
      endTime: "",
      allowedHours: "",
      overtime: "",
      approvedWorkHours: "",
      location: {id:"",title:""},
      description: "",
    };
    setRows([...rows, newRow]);
  };

  const handleSubmit = async() => {
    setLoading(true);
    const data = rows.map(row => ({
      ...row,
      contractor_data: row.contractor_data?.id ?? null,
      driver_data: row.driver_data.id ?? null,
      machine: row.machine?.id ?? null,
      location: row.location?.id ?? null,
      state: tabRowState,
    }));

    const storeData = await storeStop(data);
    setLoading(false);
    if(storeData.status === "success"){
      setRows([
        {
          id: activeRowId,
          startDate: "",
          endDate: "",
          contractor_data: {id:"","title":""},
          driver_data: {id:"",title:""},
          machine: {id:"",title:""},
          startTime: "",
          endTime: "",
          allowedHours: "",
          overtime: "",
          approvedWorkHours: "",
          location: {id:"",title:""},
          description: "",
        },
      ]);
      toast.success('توقف با موفقیت ثبت شد!')
    }else{
      toast.error("خطا در ثبت توقف!")
    }
  };

  const handlePeymankarSelect = (data) => {
    if (activeRowId) {
      handleInputChange(activeRowId, "contractor_data", data);
    }
    setOpenModalPeymankar(false);
  };
  const handleDriverSelect = (data) => {
    if (activeRowId) {
      handleInputChange(activeRowId, "driver_data", data);
    }
    setOpenModalDriver(false);
  };
  const handleLocationSelect = (data) => {
    if (activeRowId) {
      handleInputChange(activeRowId, "location", data);
    }
    setOpenModalLocation(false);
  };
  const handleMachineSelect = (data) => {
    if (activeRowId) {
      if(tabRowState === 1){
        setDrivers(data.drivers.length > 0 ? data.drivers :[]);
        const updatedRows = rows.map((row) =>
          row.id === activeRowId
            ? {
              ...row,
              machine: data,
              driver_data: data.drivers.length > 0 ? data.drivers[0] : "",
            }
            : row
        );
        setRows(updatedRows);
      }else{
        setDrivers(data.operators.length > 0 ? data.operators :[]);
        const updatedRows = rows.map((row) =>
          row.id === activeRowId
            ? {
              ...row,
              machine: data,
              driver_data: data.operators.length > 0 ? data.operators[0] : "",
            }
            : row
        );
        setRows(updatedRows);
      }

    }
    setOpenModal(false);
  };

  return (
    <>
      <ModalSelectPeymankar
        setShowModal={(state) => setOpenModalPeymankar(state)}
        setData={""}
        onSelectedIdsChange={handlePeymankarSelect}
        showModal={openModalPeymankar}
      />
      <ModalSelectEquipment setShowModal={(state)=>{
        setOpenModalEquipment(state)
      }} setData={""} onSelectedIdsChange={handleMachineSelect} showModal={openModalEquipment} />
      <ModalDriverSingleWithData data={drivers} setShowModal={(state)=>{
        setOpenModalDriver(state)
      }} setData={""} onSelectedIdsChange={handleDriverSelect} showModal={openModalDriver} />
      <ModalSelectLocation setShowModal={(state)=>{
        setOpenModalLocation(state)
      }} setData={""} onSelectedIdsChange={handleLocationSelect} showModal={openModalLocation} />
      <ModalSelectMachine setShowModal={(state)=>{
        setOpenModal(state)
      }} setData={""} onSelectedIdsChange={handleMachineSelect} showModal={openModal} />
      <DashboardLayout>
        <div className="flex !h-screen w-full flex-col">
          <div className="flex flex-wrap justify-between items-center gap-4">
            <Tabs aria-label="Options" color="primary" variant="bordered" onSelectionChange={(index)=>{
              setRows(rows.map(row => ({
                ...row,
                machine: {id:"",title:""},
                driver_data: {id:"",name:""},
              })));
              if(index === 'device-usage') {
                setTabRowState(1)
              }else {
                setTabRowState(2)
              }
            }}>
              <Tab
                key="device-usage"
                title={
                  <div className="flex items-center space-x-2 gap-2">
                    <FaTruck size={20} />
                    <span>توقف دستگاه</span>
                  </div>
                }
              />
              <Tab
                key="equipment-usage"
                title={
                  <div className="flex items-center space-x-2 gap-2">
                    <FaTools size={20} />
                    <span>توقف تجهیز بارگیری</span>
                  </div>
                }
              />
            </Tabs>

            <div className={"gap-2 flex"}>
              <Button
                onPress={handleSubmit}
                variant="contained"
                color="primary"
                isLoading={loading}
                startContent={<Sync color={"white"} size={35} />}
                className={"flex !bg-green-800 rounded-md gap-2 !text-white"}
                style={{ marginTop: "16px" }}
              >
                ثبت نهایی توقف
              </Button>
              <Button
                onPress={handleAddRow}
                variant="contained"
                color="primary"
                startContent={<AddOutlined color={"white"} size={35} />}
                className={"flex !bg-blue-500 gap-2 rounded-md !text-white"}
                style={{ marginTop: "16px" }}
              >
                افزودن ردیف جدید
              </Button>
            </div>
          </div>
          <div className="flex flex-grow flex-col p-2">
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                <tr>
                  <th style={{ ...styles.th }}>تاریخ شروع</th>
                  <th style={{ ...styles.th }}>تاریخ پایان</th>
                  <th style={{ ...styles.th }}>پیمانکار</th>
                  <th style={{ ...styles.th }}>دستگاه - تجهیز بارگیری</th>
                  <th style={{ ...styles.th }}>راننده - اپراتور</th>
                  <th style={{ ...styles.th }}>ساعت شروع</th>
                  <th style={{ ...styles.th }}>ساعت پایان</th>
                  <th style={{ ...styles.th }}>ساعت مجاز</th>
                  <th style={{ ...styles.th }}>ساعت کار تایید</th>
                  <th style={{ ...styles.th }}>محل استقرار</th>
                  <th style={{ ...styles.th }}>شرح</th>
                </tr>
                </thead>
                <tbody>
                {rows.map((row) => (
                  <tr key={row.id} style={styles.tr}>
                    <td style={styles.td}>
                      <Datepicker
                        value={row.startDate}
                        input={
                          <input
                            type="date"
                            placeholder={"تاریخ شروع"}
                            className={"form-control text-sm flex-1 border-1 border-[#ccc] rounded-md p-2.5 pr-8"}
                          />
                        }
                        adjustPosition={"modal"}
                        onChange={(val) => {
                          handleInputChange(row.id, "startDate", val.format());
                        }}
                      />
                    </td>
                    <td style={styles.td}>
                      <Datepicker
                        input={
                          <input
                            type="date"
                            placeholder={"تاریخ پایان"}
                            className={"form-control text-sm flex-1 border-1 border-[#ccc] rounded-md p-2.5 pr-8"}
                          />
                        }
                        adjustPosition={"modal"}
                        type="date"
                        value={row.endDate}
                        onChange={(val) =>
                          handleInputChange(row.id, "endDate", val.format())
                        }
                        style={styles.input}
                      />
                    </td>
                    <td style={styles.td}>
                      <input
                        type="text"
                        onClick={() => {
                          setActiveRowId(row.id);
                          setOpenModalPeymankar(true);
                        }}
                        readOnly={true}
                        value={row.contractor_data.title}
                        style={styles.input}
                      />
                    </td>
                    <td style={styles.td}>
                      <input
                        readOnly={true}
                        onClick={() => {
                          setActiveRowId(row.id);
                          if(tabRowState === 1){
                            setOpenModal(true);
                          }else{
                            setOpenModalEquipment(true);
                            }
                        }}
                        type="text"
                        value={row.machine.title}
                        onChange={(e) =>
                          handleInputChange(row.id, "machine", e.target.value)
                        }
                        style={styles.input}
                      />
                    </td>
                    <td style={styles.td}>
                      <input
                        type="text"
                        onClick={() => {
                          setActiveRowId(row.id);
                          setOpenModalDriver(true);
                        }}
                        readOnly={true}
                        value={row.driver_data.name}
                        onChange={(e) =>
                          handleInputChange(row.id, "driver_data", e.target.value)
                        }
                        style={styles.input}
                      />
                    </td>

                    <td style={styles.td}>
                      <TimeInput24h
                        value={row.startTime}
                        onChange={(value) => handleInputChange(row.id, "startTime", value)}
                      />
                    </td>
                    <td style={styles.td}>
                      <TimeInput24h
                        value={row.endTime}
                        onChange={(value) => handleInputChange(row.id, "endTime", value)}
                      />
                    </td>
                    <td style={styles.td}>
                      <TimeInput24h
                        value={row.allowedHours}
                        onChange={(value) => handleInputChange(row.id, "allowedHours", value)}
                      />
                    </td>
                    <td style={styles.td}>
                      <TimeInput24h
                        value={row.approvedWorkHours}
                        onChange={(value) => handleInputChange(row.id, "approvedWorkHours", value)}
                      />
                    </td>
                    <td style={styles.td}>
                      <input
                        readOnly={true}
                        onClick={() => {
                          setActiveRowId(row.id);
                          setOpenModalLocation(true);
                        }}
                        type="text"
                        value={row.location.title}
                        onChange={(e) =>
                          handleInputChange(row.id, "location", e.target.value)
                        }
                        style={styles.input}
                      />
                    </td>
                    <td style={styles.td}>
                      <input
                        type="text"
                        value={row.description}
                        onChange={(e) =>
                          handleInputChange(row.id, "description", e.target.value)
                        }
                        style={styles.textArea}
                      />
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
}

const styles = {
  tableContainer: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #ddd",
  },
  th: {
    fontSize: "14px",
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  tr: {
    borderBottom: "1px solid #ddd",
  },
  td: {
    width: "180px",
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  input: {
    width: "180px",
    height: "40px",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
  },
  textArea: {
    fontSize: "14px",
    width: "210px",
    height: "40px",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
};